import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "chaos-session-token";

export const tokenStore = {
  get: () => {
    if (typeof window === "undefined") return null;
    try {
      return window.localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set: (value) => {
    if (typeof window === "undefined") return;
    try {
      if (value) window.localStorage.setItem(TOKEN_KEY, value);
      else window.localStorage.removeItem(TOKEN_KEY);
    } catch {
      /* storage blocked */
    }
  },
  clear: () => tokenStore.set(null),
};

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

export const AuthAPI = {
  me: () => api.get("/auth/me").then((r) => r.data),
  google: (sessionId) =>
    api.post("/auth/google", { session_id: sessionId }).then((r) => r.data),
  requestEmail: (email) =>
    api.post("/auth/email/request", { email }).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};

const GUEST_DEVICE_KEY = "cmh-guest-device-id";
const readGuestDeviceId = () => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(GUEST_DEVICE_KEY);
  } catch {
    return null;
  }
};

export const ScanAPI = {
  execute: (query) => api.post("/scan", { query }).then((r) => r.data),
  executeGuest: (query) => {
    const deviceId = readGuestDeviceId();
    return api
      .post(
        "/scan/guest",
        { query },
        deviceId ? { headers: { "X-Guest-Device-Id": deviceId } } : undefined
      )
      .then((r) => r.data);
  },
  fastCheck: (query, scanId) =>
    api
      .post("/scan/fast-check", scanId ? { query, scan_id: scanId } : { query })
      .then((r) => r.data),
  recent: () => api.get("/scan/recent").then((r) => r.data),
  detail: (scanId) => api.get(`/scan/${scanId}`).then((r) => r.data),
};

export const ProfileAPI = {
  me: () => api.get("/profile/me").then((r) => r.data),
  resetCredits: () => api.post("/profile/reset-credits").then((r) => r.data),
  claimGuestBonus: () =>
    api.post("/profile/claim-guest-bonus").then((r) => r.data),
};

export const BillingAPI = {
  packages: () => api.get("/billing/packages").then((r) => r.data),
  mode: () => api.get("/billing/mode").then((r) => r.data),
  checkout: (planId) =>
    api
      .post("/billing/checkout", {
        plan_id: planId,
        origin_url: window.location.origin,
      })
      .then((r) => r.data),
  status: (sessionId) =>
    api.get(`/billing/status/${sessionId}`).then((r) => r.data),
};

export const ReviewAPI = {
  submit: (payload) =>
    api.post("/reviews", payload).then((r) => r.data),
};

export { API_BASE };
